<template>
        <div class="grid grid-cols-[auto_3rem] gap-1 gap-x-5">
            <div
                v-for="row in breakdown"
                :key="row.key"
                class="grid grid-cols-subgrid col-span-2 items-center"
            >
                <span class="text-sm text-zinc-500">{{ row.label }}</span>
                <span class="text-lg font-bold text-green-600 text-end" :class="row.key == 'miss' ? 'text-red-600' : 'text-green-600'">{{ row.count }}</span>
            </div>
        </div>
</template>

<script>
import { DART_TYPES } from '@/constants/dartTypes.js'

export default {
    name: 'SegmentsHitBreakdown',
    props: {
        darts: {
            type: Array,
            default: () => [],
        },
        enteredDarts: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        allDarts() {
            return [...this.darts, ...this.enteredDarts]
        },
        breakdown() {
            const counts = { single: 0, double: 0, triple: 0, miss: 0 }
            this.allDarts.forEach((dart) => {
                // The bullseye is the double bull (it scores 2, like a double).
                if (dart.dart_type === DART_TYPES.DOUBLE || dart.dart_type === DART_TYPES.BULL) {
                    counts.double++
                } else if (dart.dart_type === DART_TYPES.TRIPLE) {
                    counts.triple++
                } else if (dart.dart_type === DART_TYPES.MISS) {
                    counts.miss++
                } else {
                    counts.single++
                }
            })
            return [
                { key: 'single', label: this.$t('game_stats.segments_singles'), count: counts.single },
                { key: 'double', label: this.$t('game_stats.segments_doubles'), count: counts.double },
                { key: 'triple', label: this.$t('game_stats.segments_triples'), count: counts.triple },
                { key: 'miss', label: this.$t('game_stats.segments_misses'), count: counts.miss },
            ]
        },
    },
}
</script>
